const ONBOARDING_PAPER_CLASS_NAME = 'onboardingPaper';

export default ONBOARDING_PAPER_CLASS_NAME;
